import { useContext } from "react";
import { ApplyWithSeekContext } from "../contexts/apply_with_seek_context";

export const useApplyWithSeek = () => {
  return useContext(ApplyWithSeekContext);
};
